import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Award, ArrowRight } from 'lucide-react';
const notThis = ['This is not a random collection of makeup PDFs.', 'This is not a basic beauty ebook.', 'This is not a folder full of disconnected tutorials.', 'This is not a theoretical manual you still have to turn into real classes yourself.'];
const insteadOf = [{
  before: 'Instead of asking yourself: “What should I teach next?”',
  after: 'you can open the material and start from an organized structure.'
}, {
  before: 'Instead of explaining a technique only with words...',
  after: 'you can show the visual.'
}, {
  before: 'Instead of telling a student: “Blend it better.”',
  after: 'you can identify the mistake, show the correction and give them a clear retry task.'
}, {
  before: 'Instead of guessing whether a student is progressing...',
  after: 'you can use structured assessments and skill levels.'
}];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-stone-100 border-y border-stone-200" data-id="element-248" data-mp="2buxh7bjzypbg">
      <div className="max-w-4xl mx-auto text-center" data-id="element-249" data-mp="2gu0m8vzz8vjf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-250" data-mp="2gwmukxuozf2p">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-rose-700/10 text-rose-700 mb-5" data-id="element-251" data-mp="1x7ujp4vocgo4">
            <Award size={26} aria-hidden="true" data-id="element-252" data-mp="224ci7n0evis0" />
          </div>
          <p className="text-rose-700 font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-253" data-mp="26wvwynau4jye">
            The Complete Professional Teaching System
          </p>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-stone-800" data-id="element-254" data-mp="19fdzanogscln">
            Makeup Instructor Ready
          </h2>
          <p className="text-base md:text-lg text-stone-600 mb-10" data-id="element-255" data-mp="2hqfjnrsuw6xl">
            6 Complete Visual Volumes · 150 Ready-to-Teach Makeup Classes · 5
            Exclusive Bonuses
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-256" data-mp="2qihkhr6u7p8e">
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white p-6 rounded-2xl border border-stone-200" data-id="element-257" data-mp="2mi7dcb7b6sry">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-258" data-mp="3j7orlekcxn59">
                <X className="text-rose-800 shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-259" data-mp="3jaav9344nii7" />
                <p className="text-stone-500 text-sm" data-id="element-260" data-mp="3mp2snjcim871">{item}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-rose-700/10 p-6 rounded-2xl border border-rose-700/30 flex" data-id="element-261" data-mp="3qt22xk77cary">
            <div className="flex items-start gap-3" data-id="element-262" data-mp="3vpshu479t0bs">
              <Check className="text-rose-900 shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-263" data-mp="3vozhpm2th92m" />
              <p className="text-stone-800 font-medium text-base leading-relaxed" data-id="element-264" data-mp="s9bmm5o5wnv7">
                This is a complete 6-in-1 visual teaching system created
                specifically for makeup educators.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-6 bg-white rounded-2xl border border-stone-200 divide-y divide-stone-200 text-left" data-id="element-265" data-mp="30i9y9e7mnihr">
          {insteadOf.map(row => <li key={row.before} className="grid md:grid-cols-[1fr_auto_1fr] gap-2 md:gap-4 items-start md:items-center p-5" data-id="element-266" data-mp="3ei18d3v0weqh">
              <p className="text-stone-500 text-sm" data-id="element-267" data-mp="39hnb8guymp78">{row.before}</p>
              <ArrowRight size={18} className="text-rose-700 hidden md:block" aria-hidden="true" data-id="element-268" data-mp="av2cfgcgvrjp" />
              <p className="text-stone-800 font-medium text-base" data-id="element-269" data-mp="deff32kw5kpi">
                {row.after}
              </p>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}